import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';

/**
 * Best-effort refresh-token revocation, used by the lock / switch-seller action.
 * The caller clears the local seller session synchronously (so the route guard
 * sees a signed-out terminal immediately) and fires this in the background — a
 * failed revoke must never block locking the till, so the query function never
 * rejects and the result is ignored.
 */
export const useLogoutMutation = () => {
    const { apiClient } = useApi();

    return useMutation<ApiResponse<void>, Error, string>({
        mutationFn: (refreshToken) => apiClient.auth.logout(refreshToken),
    });
};
